export type UseManifestProps = {
  enabled: boolean;
  site: string;
}

export function useManifest({ enabled, site }: UseManifestProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <link rel='manifest' href={`/manifest/${site}.json`} />
  )
}